import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getI18nByApp } from '../services/i18n/selector';

import StepsComponent from './StepsComponent';
import ButtonComponent from './button/ButtonComponent';

import { HowItWorksContainer } from './HowItWorksComponentStyle';

class HowItWorksComponent extends React.Component {
    constructor(props) {
        super(props);
        // Force ebon display, use props values instead if it needs to be reactivated
        this.state = { isOffline: false, isEbon: true };
    }

    handleOnClick = mode => {
        if (mode === 'ebon') {
            this.setState({
                isEbon: !this.state.isEbon,
                isOffline: false
            });
        } else if (mode === 'offline') {
            this.setState({
                isEbon: false,
                isOffline: !this.state.isOffline
            });
        } else {
            this.setState({
                isEbon: false,
                isOffline: false
            });
        }
    };

    render() {
        const { i18n, topShadow, showTitle, cssClass, noPadding } = this.props;

        // Force ebon display without buttons everywhere
        // use props values instead if it needs to be reactivated
        const isEbon = true;
        const isOffline = false;
        const showButtons = false;

        return (
            <HowItWorksContainer
                className={`${topShadow ? ' cmt-ca-marche-shadow' : ''}`}
                noPadding={noPadding}>
                <div className={cssClass}>
                    {showTitle && (
                        <h2>
                            {isEbon
                                ? getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.TITLE_EBON')
                                : getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.TITLE')}
                        </h2>
                    )}
                    {showButtons && (
                        <div className="buttonWrapper">
                            <ButtonComponent
                                color="main"
                                text={getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.BOUTON_ON')}
                                cssClass={`styledButton ${
                                    !this.state.isOffline && !this.state.isEbon ? 'disabled' : ''
                                }`}
                                onClick={
                                    this.state.isOffline || this.state.isEbon
                                        ? () => this.handleOnClick('online')
                                        : null
                                }
                            />
                            <ButtonComponent
                                color="main"
                                text={getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.BOUTON_OFF')}
                                cssClass={`styledButton ${this.state.isOffline ? 'disabled' : ''}`}
                                onClick={
                                    !this.state.isOffline
                                        ? () => this.handleOnClick('offline')
                                        : null
                                }
                            />
                            <ButtonComponent
                                color="main"
                                text={getI18nByApp(i18n, 'feature.aide.HOW_IT_WORKS.BOUTON_EBON')}
                                cssClass={`styledButton ${this.state.isEbon ? 'disabled' : ''}`}
                                onClick={
                                    !this.state.isEbon ? () => this.handleOnClick('ebon') : null
                                }
                            />
                        </div>
                    )}
                    <StepsComponent
                        isOffline={showButtons ? this.state.isOffline : isOffline}
                        isEbon={showButtons ? this.state.isEbon : isEbon}
                    />
                </div>
            </HowItWorksContainer>
        );
    }
}

HowItWorksComponent.propTypes = {
    showTitle: PropTypes.bool,
    showButtons: PropTypes.bool,
    isOffline: PropTypes.bool,
    topShadow: PropTypes.bool,
    cssClass: PropTypes.string,
    i18n: PropTypes.object.isRequired
};

const mapStoreToProps = state => ({
    i18n: state.i18n
});

export default connect(mapStoreToProps)(HowItWorksComponent);



// WEBPACK FOOTER //
// ./src/components/HowItWorksComponent.js